import "./dashboard-ui.css";

export default function SearchBox({ placeholder = "Rechercher...", onChange, className = "" }) {
  return (
    <div className={`input-group ${className}`}>
      <span className="input-group-text">
        <i className="mdi mdi-magnify"></i>
      </span>
      <input type="search" className="form-control border-start-0 ps-0" placeholder={placeholder} onChange={onChange} />
    </div>
  );
}
